/**
 * Что видит человек, открывший адрес приложения в обычном браузере.
 *
 * Записаться отсюда нельзя: запись требует подписи Telegram, которой вне
 * мессенджера просто нет. Показывать при этом рабочий экран записи — обман:
 * человек выберет услугу и время, а на последнем шаге получит отказ.
 */

const MASTER_BOT = import.meta.env.VITE_MASTER_BOT_USERNAME || 'ZapiZapisBot';

export function OutsideTelegram() {
  const botLink = `https://t.me/${MASTER_BOT}`;

  return (
    <div className="app">
      <div className="landing">
        <h1 className="title">Zapi</h1>
        <p className="subtitle">Запись к мастеру прямо в Telegram</p>

        <p className="landing-text">
          Эта страница — приложение записи. Оно открывается внутри Telegram: там
          мастер видит, кто записался, а вы получаете напоминания о визите.
        </p>

        <a className="button" href={botLink}>
          Открыть в Telegram
        </a>

        <p className="landing-text">
          Вы мастер и хотите принимать записи? Напишите боту команду{' '}
          <b>/newbot</b> — свой бот записи создаётся за минуту, без настройки
          и токенов.
        </p>

        <p className="landing-text">
          <a href="/legal/offer.html">Оферта</a>
          {' · '}
          <a href="/legal/privacy.html">Персональные данные</a>
        </p>
      </div>
    </div>
  );
}
